import React, { Component } from 'react';
import _ from 'lodash';
import { GoogleLogin, GoogleLogout } from 'react-google-login';

const calendarScopes = ["https://www.googleapis.com/auth/calendar.readonly", "https://www.googleapis.com/auth/calendar"]

class BendTimePopup extends Component {
    render() {
        return (
            <div>
                <div className="popup-option" style={this.props.showEventsInput ? {} : { display: 'none' }}>
                    <div className="popup-container">
                        <div className="google-connect">
                            <div className="col">
                                <label>Google Account</label>
                            </div>
                            <div className="col">
                                <GoogleLogin
                                    clientId="843362412747-tkvh7rq60tmmrfupotemtp6qnq49668o.apps.googleusercontent.com"
                                    buttonText="Login"
                                    scope="profile email https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar"
                                    onSuccess={this.props.oAuthSuccess}
                                    onFailure={this.props.oAuthFailure}
                                />

                                <GoogleLogout
                                    buttonText="Logout"
                                    onLogoutSuccess={this.props.oAuthLogout}
                                />
                            </div>
                        </div>
                        <div style={this.props.showCalendarSelection ? {} : { display: 'none' }}>
                            <div className="col">
                                <label>Select Calendar</label>
                            </div>
                            <div className="col">
                                <select key={'events'} onChange={this.props.onCalendarChange}>
                                    {_.map(this.props.calendars, ({ id, summary }) => {
                                        return <option key={id} value={id}>{summary}</option>
                                    })}
                                </select>
                                <button onClick={this.props.refreshEvents}>Refresh</button>
                            </div>
                        </div>
                        <div>
                            <div className="col">
                                <button onClick={this.props.clearEvents}>Clear</button>
                            </div>
                            <div className="col">
                                <button onClick={this.props.setEvents}>Set</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default BendTimePopup;